// Незамокать отсутствие window
/* istanbul ignore next */
export function isStorageEnable(): boolean {
  return typeof window !== 'undefined' && Boolean(window.sessionStorage) && Boolean(window.sessionStorage.getItem);
}
